import React from 'react'
import './DescriptionBox.css'

function DescriptionBox() {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="description-nav-box">Description</div>
            <div className="description-nav-box">Reviews (222)</div>
        </div>
        <div className="descriptionbox-description">
            <p> An e-commerce website is an online platform that facilitates the buying and selling of products or services over the internet. 
            It serves as a virtual marketplace where businesses and individuals can showcase their products, interact with customers, 
            and conduct transactions without the need for a physical presence. 

         E-commerce websites have gained immense popularity due to their convenience, accessibility, and the global reach they offer. 
         Customers can browse a wide range of products, compare prices, read reviews, and make purchases from anywhere at any time. </p>
        <p>These websites typically display products with detailed descriptions, images, prices, and available variations 
        (such as sizes, colors, and styles). Each product usually has its own dedicated page with relevant information 
         to help customers make informed decisions.</p>
        </div>
    </div>
  )
}

export default DescriptionBox